module.exports = __webpack_public_path__ + "static/media/movement_32_blue.1b83b22d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/movement_32_blue.svg
// module id = 514
// module chunks = 0